$ ->
  prevent = (ev) ->
    ev.preventDefault()
    false

  $('.remote_with_feedback').each ->
    the_link = $(this)
    target = if the_link.is("[data-remote='true']")
               the_link
             else
               the_link.closest("[data-remote='true']")
    target.on 'ajax:send', ->
      if the_link.attr('href')
        the_link.on 'click', prevent
      else
        the_link.prop('disabled', true)
      the_link.addClass('disabled')
      the_link.append('<i class="fa fa-refresh fa-spin" aria-hidden="true"></i>')

    target.on 'ajax:complete', ->
      the_link.find('i.fa').attr('class', 'fa fa-check done')
      setTimeout(
        ->
          the_link.find('i.fa').remove()
          if the_link.attr('href')
            the_link.off 'click', prevent
          else
            the_link.prop('disabled', false)
          the_link.removeClass('disabled')
        , 5000
      )
